

















































































































































































































































































































































































































import {Component, Watch, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {urlWithContour} from "@/helpers/currentContour";
import VueQrcode from 'vue-qrcode'
import Alert from '@/components/UI/Alert.vue';
import IArrow from '@/components/icons/IArrow.vue'
import EditItem from '@/components/UI/EditItem.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import ICopy from "@/components/icons/ICopy.vue";

const profile = namespace('profile')
const workspace = namespace('workspace')
const resources = namespace('resources')

@Component({
  components: {
    ICopy,
    VueQrcode,
    Alert,
    IArrow,
    EditItem,
    BtnDefault,
  }
})

export default class Profile extends Vue {
  @profile.Action('getCompanyInfoFromServer') protected getCompanyInfoFromServer: any
  @profile.Action('saveCompanyInfo') protected saveCompanyInfo: any
  @profile.Getter('getCompanyInfo') protected getCompanyInfo: any

  @workspace.Getter('getCurrentExhibition') protected getCurrentExhibition: any

  @resources.Getter('getCountries') protected getCountries: any
  @resources.Action('getCountryFromServer') protected getCountryFromServer: any

  panel: any = [0, 1]
  search: string = ''
  loading: boolean = true
  country: any = ''
  type: string = ''
  newContact: any = {
    type: '',
    value: ''
  }
  newLocation: any = {
    _country: '',
    region: '',
    city: '',
    address: '',
    postcode: ''
  }
  newPromo: any = {
    title: '',
    value: ''
  }
  stands: any = []
  isError: any = {
    contact_type: false,
    contact_value: false,
    location_country: false,
    promo_title: false,
    promo_value: false
  }
  currentLocation: any = {}

  get curProductLink() {
    return `${urlWithContour()}/c/${this.getCompanyInfo._id}`
  }

  get contacts() {
    return [
      {
        id: 'phone',
        title: this.$t('newProfile.contacts_modal.phone')
      },
      {
        id: 'email',
        title: this.$t('newProfile.contacts_modal.email')
      },
      {
        id: 'site',
        title: this.$t('newProfile.contacts_modal.site')
      },
      {
        id: 'location',
        title: this.$t('newProfile.locations.title')
      },
    ]
  }

  @Watch('getCurrentExhibition')
  async getCompany() {
    this.loading = true
    await this.getCompanyInfoFromServer({companyId: this.getCurrentExhibition.companyParticipation._id})
    if (!this.getCompanyInfo.stands || !this.getCompanyInfo.stands.length) this.getCompanyInfo.stands = ['']
    this.stands = [...this.getCompanyInfo.stands]
    this.loading = false
  }

  async mounted() {
    this.loading = true
    this.getCountryFromServer()
    if (this.getCurrentExhibition && this.getCurrentExhibition.companyParticipation) await this.getCompanyInfoFromServer({companyId: this.getCurrentExhibition.companyParticipation._id})
    if (!this.getCompanyInfo.stands || !this.getCompanyInfo.stands.length) this.getCompanyInfo.stands = ['']
    this.stands = [...this.getCompanyInfo.stands]
    if (this.getCompanyInfo.title) this.loading = false
  }

  saveChange() {

    this.saveCompanyInfo({
      params: {companyId: this.getCurrentExhibition.companyParticipation._id},
      body: this.getCompanyInfo
    })
  }

  addContact() {
    this.isError.contact_type = this.type == ''
    this.isError.contact_value = this.newContact.value == ''
    if (!this.isError.contact_type && !this.isError.contact_value) {
      this.newContact.type = this.type
      this.getCompanyInfo.contacts.push(this.newContact)
      this.newContact = {
        type: '',
        value: ''
      }
      this.type = ''
      this.saveChange()
    }
  }

  addLocation() {
    this.isError.location_country = this.newLocation._country == ''
    if (!this.isError.location_country) {
      this.getCompanyInfo.locations.push(this.newLocation)
      this.newLocation = {
        _country: '',
        region: '',
        city: '',
        address: '',
        postcode: ''
      }
      this.type = ''
      this.saveChange()
    }
  }

  addPromo() {
    this.isError.promo_title = this.newPromo.title == ''
    this.isError.promo_value = this.newPromo.value == ''
    if (!this.isError.promo_title && !this.isError.promo_value) {
      if (!this.getCompanyInfo.promo) this.getCompanyInfo.promo = []
      this.getCompanyInfo.promo.push(this.newPromo)
      this.newPromo = {
        title: '',
        value: ''
      }
      this.saveChange()
    }
  }

  getContactTitle(contact: any) {
    let title: any
    if (contact.type == 'phone') {
      title = this.$t('newProfile.contacts_modal.phone')
    } else if (contact.type == 'email') {
      title = this.$t('newProfile.contacts_modal.email')
    } else if (contact.type == 'site') {
      title = this.$t('newProfile.contacts_modal.site')
    }
    return title
  }

  getLocation(location: any) {
    let address = ''
    if (location.postcode) address += location.postcode + ', '
    if (location._country && this.getCountries.filter((country: any) => country.code == location._country).length) address += this.getCountries.filter((country: any) => country.code == location._country)[0].title + ', '
    if (location.region) address += location.region + ', '
    if (location.city) address += location.city + ', '
    if (location.address) address += location.address + ', '
    return address.slice(0, -2)
  }

  deleteItem(field: string, index: string) {
    this.getCompanyInfo[field].splice(index, 1)
    this.saveChange()
  }

  addStand() {
    this.stands.push('')
  }

  saveStands() {
    let currentStands: any = []
    this.stands.forEach((stand: any) => {
      if (stand != '') currentStands.push(stand)
    })
    this.getCompanyInfo.stands = currentStands
    this.saveChange()
  }

  saveLocation(index: number) {
    this.getCompanyInfo.locations[index] = this.currentLocation
    this.saveChange()
  }

  openModalLocation(location: any) {
    this.currentLocation = {...location}
  }

  copy(value: any) {
    let area = document.createElement('textarea');
    document.body.appendChild(area);
    area.value = value;
    area.select();
    document.execCommand("copy");
    document.body.removeChild(area);
  }

}
